document.addEventListener('DOMContentLoaded', function () {

    const section = document.querySelector(".clickable-hero");
    if (section) {
        const button = section.querySelector(".banner__button");
        if (button) {
            const link = button.getAttribute("href");
            if (link) {
                section.style.cursor = "pointer";
                section.addEventListener("click", (e) => {
                    if (e.target.closest(".banner__button")) return;
                    window.location.href = link;
                });
            }
        }
    }

    const htmlLang = document.documentElement.getAttribute('lang');
    if (htmlLang !== 'en') return;

    const translateSockPromoText = () => {
        const translatedHTML = "Discounts are automatically applied in the shopping cart.<br>👜 3 products purchased = <strong>1 free tote bag</strong> / 🧶 5 products purchased = <strong>1 free beanie</strong>";

        // Cible les .ProgressBarHeaddingText
        const headingElements = document.querySelectorAll('.ProgressBarHeaddingText');
        headingElements.forEach((element) => {
            if (element.textContent.includes("Les rabais s'appliquent automatiquement dans le panier")) {
                element.innerHTML = translatedHTML;
            }
        });

        // Cible les .ProgressBarSuccText (avec un <p> à l’intérieur)
        const successElements = document.querySelectorAll('.ProgressBarSuccText');
        successElements.forEach((element) => {
            const p = element.querySelector('p');
            if (p && p.textContent.includes("Les rabais s'appliquent automatiquement dans le panier")) {
                p.innerHTML = translatedHTML;
            }
        });
    };

    // MutationObserver pour détecter les ajouts dynamiques
    const observer = new MutationObserver(() => {
        translateSockPromoText();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Vérification initiale avec un intervalle de secours
    const interval = setInterval(() => {
        const hasText = document.querySelector('.ProgressBarHeaddingText') || document.querySelector('.ProgressBarSuccText');
        if (hasText) {
            translateSockPromoText();
            console.log('Sock promo text translated!');
            clearInterval(interval);
        }
    }, 500);
});